<script module lang="ts">
  import type { ProductVariant } from '@agapi/mlc-core';

  export interface ProductFeedProps {
    blok?: any;
  }
</script>

<script lang="ts">
  import { page } from '$app/state';

  import { untrack } from 'svelte';
  import { storyblokEditable } from "@storyblok/svelte";

  import { Section } from '@agapi/ui/section';

  import { getCommerce } from '../../../services/commerce.shared';
  import { getCookie } from '../../../utils/cookies.client';
  import { getLocaleFromUrl } from '../../../utils/locale.shared';
  import { ProductRecommendationSlider } from '../../../components';

  const { blok }: ProductFeedProps  = $props();
  const { title, type } = blok ?? {};

  let products = $state<ProductVariant[]>([]);

  // TODO: Use new filter
  // const oldFilter = { and: [ { type: "attribute", attributeName: "stock", value: 0, comparisonMode: "greaterThan" } ] };
  // const newFilter = { stock: { gt: 0 } };

  const getProductFeed = async (type: string): Promise<ProductVariant[]> => {
    const identifier = getCookie<string>('__agapi_identity') ?? 'default';
    const COMMERCE = getCommerce(window.fetch);

    switch (type) {
      case 'recommendations': return (await COMMERCE.getRecommendation({ limit: 10, }, getLocaleFromUrl(page.url), { userId: identifier })).items;
      case 'popular': return (await COMMERCE.getPopularProducts({ limit: 10, behaviorType: 'click', }, getLocaleFromUrl(page.url), { userId: identifier })).items;
      case 'recently_interacted': return (await COMMERCE.getRecentlyInteractedProducts({ limit: 10, behaviorType: 'click' }, getLocaleFromUrl(page.url), { userId: identifier })).items;
      default: return [];
    }
  }

  $effect(() => {
    if (type) {
      untrack(async () => {
        products = await getProductFeed(type);
      });
    }
  });
</script>

<Section use={[[storyblokEditable,blok]]}>
  <ProductRecommendationSlider title={title} products={products} />
</Section>
